import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { noResultsText } from '../../custom_api/api';
import { ActivitySummary } from '../components/activity_summary';
import { trackActivityClick } from './library/tracking';
import { classNamesConfig } from '../../../Shared/features/classnames';
export const ActivityCluster = (p)=>{
    const classNames = classNamesConfig().activity_cluster;
    return /*#__PURE__*/ _jsxs("section", {
        className: `block block--activity-cluster ${classNames.block}`,
        "data-anchor": p.slug,
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: `block__header ${classNames.inner}`,
                children: [
                    p.title && /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l container--xs",
                        children: p.title
                    }),
                    p.description && /*#__PURE__*/ _jsx("div", {
                        className: "block__intro container--s text--styled",
                        children: /*#__PURE__*/ _jsx("p", {
                            children: p.description
                        })
                    })
                ]
            }),
            p.activitySummaries.isEmpty() ? /*#__PURE__*/ _jsx("div", {
                className: `text--styled ${classNames.inner}`,
                children: /*#__PURE__*/ _jsx("p", {
                    className: "weight--bold container--s",
                    children: noResultsText
                })
            }) : /*#__PURE__*/ _jsx("ul", {
                className: "row teasers",
                children: p.activitySummaries.map((s, i)=>/*#__PURE__*/ _jsx(ActivitySummary, {
                        headingLevel: "h3",
                        onClick: ()=>trackActivityClick(s.title, p.title),
                        ...s
                    }, `activity-summary-${i}`))
            })
        ]
    });
};
{
/* TH: Added to styleguide! */ }